import * as Api from "@api";
import * as C from "@components";
import css from "./peace-of-mind.module.scss";

const PeaceOfMindSectionContentBaseKey = "peace-of-mind" as const;
const imageDirectory = `/images/products/@global/sections/${PeaceOfMindSectionContentBaseKey}/`;

export const PeaceOfMindSectionContentKeys = [
    `${PeaceOfMindSectionContentBaseKey}.headline`,
    `${PeaceOfMindSectionContentBaseKey}.1.headline`,
    `${PeaceOfMindSectionContentBaseKey}.1.body`,
    `${PeaceOfMindSectionContentBaseKey}.2.headline`,
    `${PeaceOfMindSectionContentBaseKey}.2.body`,
] as const;

interface PeaceOfMindSectionProps
{
    pageContent: Api.Content<typeof PeaceOfMindSectionContentKeys[number]>;
}

export const PeaceOfMindSection = ({ pageContent }: PeaceOfMindSectionProps): React.FunctionComponentElement<PeaceOfMindSectionProps> =>
    <C.ImageCardSection
        headingLeft
        headlineClassName={css["text_mobile_center"]}
        imageDirectory={imageDirectory}
        keyPrefix="peace-of-mind"
        pageContent={pageContent}
        containerProps={{ horizontalGap: 24, verticalGap: 24 }}
        cards={[
            {
                key: "1",
                stdProps: {
                    bodyMaxWidth: C.Width.W436,
                    headingMaxWidth: C.Width.W436,
                    headingTypography: C.Typography.MH2DH5,
                    imageWidth: 566,
                    imageHeight: 331,
                    mobileImageProps: {
                        mobileWidth: 768,
                        mobileHeight: 517
                    },
                    imagePosition: C.CardImagePosition.Top,
                    indentAfter: 40,
                    indentBefore: 60,
                    width: C.Width.W50P,
                    textLeft: true,
                }
            },
            {
                key: "2",
                stdProps: {
                    bodyMaxWidth: C.Width.W436,
                    headingMaxWidth: C.Width.W436,
                    headingTypography: C.Typography.MH2DH5,
                    imageWidth: 566,
                    imageHeight: 331,
                    mobileImageProps: {
                        mobileWidth: 768,
                        mobileHeight: 517
                    },
                    imagePosition: C.CardImagePosition.Top,
                    indentAfter: 40,
                    indentBefore: 60,
                    width: C.Width.W50P,
                    textLeft: true,
                }
            },
        ]}
    />